import api from './api';

const authService = {
  // User Authentication
  register: (data) => api.post('/auth/register', data),
  login: (credentials) => api.post('/auth/login', credentials),
  logout: () => api.post('/auth/logout'),
  me: () => api.get('/auth/me'),
  
  // Organizer Authentication
  registerOrganizer: (data) => api.post('/auth/organizer/register', data),
  loginOrganizer: (credentials) => api.post('/auth/organizer/login', credentials),
  
  // Agent Authentication
  loginAgent: (credentials) => api.post('/auth/agent/login', credentials),
  
  // Admin Authentication
  loginAdmin: (credentials) => api.post('/auth/admin/login', credentials),
  
  // Password Reset
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (data) => api.post('/auth/reset-password', data),
  
  // Profile
  getProfile: () => api.get('/user/profile'),
  updateProfile: (data) => api.put('/user/profile', data),
  updateFcmToken: (token) => api.post('/user/fcm-token', { token }),
};

export default authService;

